import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import axios from 'axios';
import { toast } from 'react-hot-toast';
import thanaData from './thana.json'

const Checkout = () => {
    const navigate = useNavigate();
    // const { state: { cart } } = useProducts();
    const cart = JSON.parse(localStorage.getItem("selectedCart"))
    // console.log(cart)
    const total = cart.reduce((total, product) => {
        return (total + (product.offer_price === null ? product?.price : product?.offer_price) * (product?.quantity))
    }, 0)

    // something
    const [isBillingSameAsShipping, setIsBillingSameAsShipping] = useState(false);
    const [divisionOptionsShipping, setDivisionOptionsShipping] = useState([]);
    const [districtOptionsShipping, setDistrictOptionsShipping] = useState([]);
    const [thanaOptionsShipping, setThanaOptionsShipping] = useState([]);
    const [selectedDivisionShipping, setSelectedDivisionShipping] = useState(null);
    const [selectedDistrictShipping, setSelectedDistrictShipping] = useState(null);
    const [selectedThanaShipping, setSelectedThanaShipping] = useState(null);

    const handleDivisionChangeShipping = (option) => {
        setSelectedDivisionShipping(option);
        setSelectedDistrictShipping(null);
    };

    const handleDistrictChangeShipping = (option) => {
        setSelectedDistrictShipping(option);
    };

    const handleThanaChangeShipping = (option) => {
        setSelectedThanaShipping(option);
        // setSelectedThana(null);
    };


    useEffect(() => {
        const fetchDivisionOptionsShipping = async () => {
            const response = await axios.get(`${process.env.REACT_APP_SECRET_API}/division`);
            const divisionOptionsDataShipping = response.data.data.map((option) => ({
                label: option.name,
                value: option.id,
            }));
            setDivisionOptionsShipping(divisionOptionsDataShipping);
        };

        fetchDivisionOptionsShipping();
    }, []);



    useEffect(() => {
        const fetchDistrictOptionsShipping = async () => {
            if (selectedDivisionShipping) {
                const response = await axios.get(`${process.env.REACT_APP_SECRET_API}/district?division_id=${selectedDivisionShipping.value}`);
                const districtOptionsDataShipping = response.data.data
                    .filter((option) => option.division_id === selectedDivisionShipping.value) // filter by selected division_id
                    .map((option) => ({
                        label: option.name,
                        value: option.id,

                    }));
                setDistrictOptionsShipping(districtOptionsDataShipping);
            }
        };

        fetchDistrictOptionsShipping();
    }, [selectedDivisionShipping]);

    useEffect(() => {
        const fetchThanaOptionsShipping = () => {
            if (selectedDistrictShipping) {
                const filteredThanaData = thanaData.filter(
                    (option) => option.district === selectedDistrictShipping.label
                );
                const thanaOptionsData = filteredThanaData.map((option) => ({
                    label: option.name,
                    value: option.id,
                }));
                setThanaOptionsShipping(thanaOptionsData);
            } else {
                setThanaOptionsShipping([]);
            }
        };

        fetchThanaOptionsShipping();
    }, [selectedDistrictShipping]);

    // something

    const [divisionOptions, setDivisionOptions] = useState([]);
    const [districtOptions, setDistrictOptions] = useState([]);
    const [thanaOptions, setThanaOptions] = useState([]);
    const [selectedDivision, setSelectedDivision] = useState(null);
    const [selectedDistrict, setSelectedDistrict] = useState(null);
    const [selectedThana, setSelectedThana] = useState(null);
    const [address, setAddress] = useState("");
    const [billingAddress, setBillingAddress] = useState("");


    const handleDivisionChange = (option) => {
        setSelectedDivision(option);
        setSelectedDistrict(null);
    };

    const handleDistrictChange = (option) => {
        setSelectedDistrict(option);
    };

    const handleThanaChange = (option) => {
        setSelectedThana(option);
    }

    useEffect(() => {
        const fetchDivisionOptions = async () => {
            const response = await axios.get(`${process.env.REACT_APP_SECRET_API}/division`);
            const divisionOptionsData = response.data.data.map((option) => ({
                label: option.name,
                value: option.id,
            }));
            setDivisionOptions(divisionOptionsData);
        };

        fetchDivisionOptions();
    }, []);

    useEffect(() => {
        const fetchDistrictOptions = async () => {
            if (selectedDivision) {
                const response = await axios.get(`${process.env.REACT_APP_SECRET_API}/district?division_id=${selectedDivision.value}`);
                const districtOptionsData = response.data.data
                    .filter((option) => option.division_id === selectedDivision.value) // filter by selected division_id
                    .map((option) => ({
                        label: option.name,
                        value: option.id,

                    }));
                setDistrictOptions(districtOptionsData);
            }
        };

        fetchDistrictOptions();
    }, [selectedDivision]);

    useEffect(() => {
        const fetchThanaOptions = () => {
            if (selectedDistrict) {
                const filteredThanaData = thanaData.filter(
                    (option) => option.district === selectedDistrict.label
                );
                // console.log(filteredThanaData)
                const thanaOptionsData = filteredThanaData.map((option) => ({
                    label: option.name,
                    value: option.id,
                }));
                setThanaOptions(thanaOptionsData);
            } else {
                // If no district is selected, set empty array for thanaOptions
                setThanaOptions([]);
            }
        };

        fetchThanaOptions();
    }, [selectedDistrict]);

    function handleBillingSameAsShippingChange(event) {
        setIsBillingSameAsShipping(event.target.checked);
    }
    // console.log(cart)
    const handleClick = (e) => {

        const data = [
            selectedDivision?.value,
            selectedDistrict?.value,
        ];

        const shippingAddress = address +
            (selectedDivision?.label ? `, ${selectedDivision.label}` : '') +
            (selectedDistrict?.label ? `, ${selectedDistrict.label}` : '') +
            (selectedThana?.label ? `, ${selectedThana.label}` : '')

        const billingAddressDetails = isBillingSameAsShipping
            ? shippingAddress
            : [
                billingAddress,
                selectedDivisionShipping?.label,
                selectedDistrictShipping?.label,
                selectedThanaShipping?.label
            ].filter(String).join(`, `);

        const thana = selectedThana?.label

        localStorage.setItem("shippingAddress", JSON.stringify(shippingAddress));
        localStorage.setItem("billingAddress", JSON.stringify(billingAddressDetails));
        localStorage.setItem("selectedData", JSON.stringify(data));
        localStorage.setItem("shipping_thana", JSON.stringify(thana))

        const costDetails = {
            user_division_id: selectedDivision.value,
            user_district_id: selectedDistrict.value,
            products: cart.map(item => ({ id: item.id, quantity: item.quantity, total: total }))
        }
        console.log(costDetails)

        fetch(`${process.env.REACT_APP_SECRET_API}/shipping-rate`, {
            method: "POST",
            headers: {
                "X-Requested-With": "XMLHttpRequest",
                "content-type": "application/json",
                "authorization": `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify(costDetails),
        })
            .then((res) => res.json())
            .then((data) => console.log(data))

        navigate("/shipping");
    };



    return (
        <div className='bg-white'>
            <div className="container grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2  items-center pb-16 pt-4 gap-4">
                <div>
                    <div className="p-4">
                        <h3 className="text-lg font-medium capitalize mb-4  text-black">Shipping Address</h3>
                        <div className="space-y-4">
                            <div className="w-full">
                                <div className="mb-6">
                                    <textarea cols="7" type="text" name="division" id="address"
                                        value={address}
                                        onChange={(e) => setAddress(e.target.value)}
                                        className="block w-full border bg-white border-gray-300 px-4 py-3 text-gray-600 text-sm rounded focus:ring-0 focus:border-primary placeholder-gray-400"
                                        placeholder="Address"></textarea>
                                    {address === "" && <p className='text-red-500'>Please enter your shipping address.</p>}
                                </div>
                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                    <div className="mb-6">
                                        <Select
                                            options={divisionOptions}
                                            value={selectedDivision}
                                            onChange={handleDivisionChange}
                                            isSearchable
                                            placeholder="Select a division"
                                        />
                                    </div>
                                    <div className="mb-6">
                                        <Select
                                            options={districtOptions}
                                            value={selectedDistrict}
                                            onChange={handleDistrictChange}
                                            isSearchable
                                            placeholder="Select a district"
                                            isDisabled={!selectedDivision}
                                        />
                                    </div>
                                </div>
                                <div className="mb-6">
                                    <Select
                                        options={thanaOptions}
                                        value={selectedThana}
                                        onChange={handleThanaChange}
                                        placeholder="Select a area"
                                        isDisabled={!selectedDistrict}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Billing Address */}
                    <div>
                        <label className='text-sm ml-4 flex items-center '>
                            <input type="checkbox" className="checkbox rounded-none checkbox-info checkbox-xs" checked={isBillingSameAsShipping} onChange={handleBillingSameAsShippingChange} />
                            <span className='pl-2'>Same as Shipping Address</span>
                        </label>
                    </div>
                    {!isBillingSameAsShipping && (
                        <>
                            <div className="p-4">
                                <h3 className="text-lg font-medium capitalize mb-4  text-black">Billing Address</h3>
                                <div className="space-y-4">
                                    <div className="w-full">
                                        <div className="mb-6">
                                            <textarea cols="7" type="text" name="division" id="address"
                                                value={billingAddress}
                                                onChange={(e) => setBillingAddress(e.target.value)}
                                                className="block w-full border bg-white border-gray-300 px-4 py-3 text-gray-600 text-sm rounded focus:ring-0 focus:border-primary placeholder-gray-400"
                                                placeholder="Address"></textarea>
                                            {billingAddress === "" && <p className='text-red-500 text-sm'>Please enter your billing address.</p>}
                                        </div>
                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                            <div className="mb-6">
                                                <Select
                                                    options={divisionOptionsShipping}
                                                    value={selectedDivisionShipping}
                                                    onChange={handleDivisionChangeShipping}
                                                    isSearchable
                                                    placeholder="Select a division"
                                                />
                                            </div>
                                            <div className="mb-6">
                                                <Select
                                                    options={districtOptionsShipping}
                                                    value={selectedDistrictShipping}
                                                    onChange={handleDistrictChangeShipping}
                                                    isSearchable
                                                    placeholder="Select a district"
                                                    isDisabled={!selectedDivisionShipping}
                                                />
                                            </div>
                                        </div>
                                        <div className="mb-6">
                                            <Select
                                                options={thanaOptionsShipping}
                                                value={selectedThanaShipping}
                                                onChange={handleThanaChangeShipping}
                                                placeholder="Select a area"
                                                isDisabled={!selectedDistrictShipping}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
                <div className="p-4">
                    <h4 className="text-gray-800 text-lg mb-4 font-medium uppercase">order summary</h4>
                    <div className="space-y-2">
                        <div className="overflow-x-auto w-full">
                            <table className="table w-full static -z-10">
                                <thead>
                                    <tr>
                                        <th className="z-0 border-0 rounded-none static" style={{ zIndex: "0" }}></th>
                                        <th className="z-0 border-0 static" style={{ zIndex: "0" }}>Name</th>
                                        <th className="z-0 border-0 static">Qty</th>
                                        <th className="z-0 border-0 rounded-none static">price</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {cart.map((product, index) => (
                                        <tr key={index}>
                                            <th className="z-0 border-0 static" style={{ zIndex: "0" }}>{index + 1}</th>
                                            <td className="z-0 static">{product.name}</td>
                                            <td>{product.quantity}</td>
                                            <td className="z-0 static"><span className='
                                             text-[25px] font-bold'>৳</span>{product?.offer_price === null ? product?.quantity * product?.price : product?.quantity * product?.offer_price}</td>
                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                        </div>
                        <div className="flex  justify-between text-gray-800 font-medium py-3 uppercase">
                            <p className="font-semibold">Total</p>
                            <p><span className='text-[25px] font-bold'>৳</span>{total}</p>
                        </div>
                    </div>

                    {selectedThana || selectedThanaShipping ?
                        (
                            <button onClick={handleClick}
                                className={`block w-full mt-4 py-2 text-center text-white 
                    ${(!selectedThana && !selectedThanaShipping) ? 'bg-gradient-to-l from-red-500 to-[#52a3eb] hover:from-[red] hover:to-primary cursor-not-allowed' : 'bg-gradient-to-l from-primary to-[#52a3eb] hover:from-[#52a3eb] hover:to-primary ease-in-out delay-150 duration-300 transition'}
                    `}
                                disabled={cart.some(product => product.stock === 0 && product.quantity > product.stock)}
                            >
                                Confirm Order
                            </button>
                        ) : (
                            <button onClick={() => toast.error("Please select Division, District and Thana", {
                                icon: "⚠️",
                            })} className="block cursor-not-allowed w-full mt-4 py-2 text-center text-white bg-gradient-to-l from-red-500 to-[#52a3eb] hover:from-[red] hover:to-primary ease-in-out delay-150 duration-300 transition">
                                Confirm Order
                            </button>
                        )
                    }
                </div>
            </div>
        </div >


    );
};

export default Checkout;